import React, { Component, createContext } from 'react'

export const SnackBarContext = createContext()

export class SnackBarContextProvider extends Component {
  constructor () {
    super()
    this.state = { feedback: null, id: null, keepOpen: false }
  }

  setFeedback = (value, id = Date.now(), keepOpen = false) => {
    this.setState({
      feedback: value,
      id,
      keepOpen
    })
  }

  render () {
    const { children } = this.props
    const { feedback, id, keepOpen } = this.state
    const { setFeedback } = this
    return (
      <SnackBarContext.Provider value={{ setFeedback, feedback, id, keepOpen }}>
        {children}
      </SnackBarContext.Provider>
    )
  }
}
